import { render, staticRenderFns } from "./DetailSubprojects.vue?vue&type=template&id=48594630&scoped=true"
import script from "./DetailSubprojects.vue?vue&type=script&lang=js"
export * from "./DetailSubprojects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48594630",
  null
  
)

export default component.exports